<template>
  <lazy-component @show="handleShow">
    <div class="lab_section">
      <div class="columns is-multiline is-mobile">
        <div
          class="column is-one-quarter-tablet is-one-quarter-desktop is-2-widescreen is-12-mobile lab-col"
        >
          <div class="bluebox box">
            {{ lab.name }}
          </div>
        </div>
        <div
          class="column is-one-quarter-tablet is-one-quarter-desktop is-2-widescreen is-12-mobile student-col"
          v-for="(student, idx) in lab.items"
          :key="idx"
        >
          <Thumbnail
            v-show="visibleToggle"
            :src="student.slide_url"
            :target="student.video_url"
            :placeholder="defaultImage"
            :caption="student.first + ' ' + student.last"
          />
        </div>
      </div>
    </div>
  </lazy-component>
</template>
<script>
import Thumbnail from "@/components/thumbs/Thumbnail.vue";
export default {
  name: "",
  props: ["lab"],
  components: {
    Thumbnail
  },
  data: () => ({
    defaultImage: "https://via.placeholder.com/300x200/fff/?text=Loading",
    visibleToggle: false
  }),
  methods: {
    handleShow() {
      this.visibleToggle = true;
    }
  }
};
</script>
<style>
.bluebox.box {
  background-color: navy;
  color: white;
  border-radius: 0;
  display: flex;
  height: 99%;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
